export default __webpack_public_path__ + "static/media/Arch_Amazon-CloudWatch_64.574a8a91.svg";